import type {
  TimelineAnalysisCancelResponseInput as TimelineAnalysisCancelResponseInputType,
  TimelineAnalysisCancelResponseOutput as TimelineAnalysisCancelResponseOutputType,
  TimelineAnalysisRealtimeTokenInput as TimelineAnalysisRealtimeTokenInputType,
  TimelineAnalysisRealtimeTokenOutput as TimelineAnalysisRealtimeTokenOutputType,
  TimelineAnalysisSettingsResponseInput as TimelineAnalysisSettingsResponseInputType,
  TimelineAnalysisSettingsResponseOutput as TimelineAnalysisSettingsResponseOutputType,
} from './analysis';
import type {
  TimelineInsightsResponseInput as TimelineInsightsResponseInputType,
  TimelineInsightsResponseOutput as TimelineInsightsResponseOutputType,
} from './insights';
import type {
  MentionsTimelineResponse as MentionsTimelineResponseType,
  TimelinePageResponse as TimelinePageResponseType,
} from './schemas';
import type {
  MentionsTimelineResponseInput as MentionsTimelineResponseInputType,
  MentionsTimelineResponseOutput as MentionsTimelineResponseOutputType,
  ProfileStatusResponseInput as ProfileStatusResponseInputType,
  ProfileStatusResponseOutput as ProfileStatusResponseOutputType,
  TimelineInsightsSyncResponseInput as TimelineInsightsSyncResponseInputType,
  TimelineInsightsSyncResponseOutput as TimelineInsightsSyncResponseOutputType,
  TimelineLinkInsightsPayloadInput as TimelineLinkInsightsPayloadInputType,
  TimelineLinkInsightsPayloadOutput as TimelineLinkInsightsPayloadOutputType,
  TimelinePageResponseInput as TimelinePageResponseInputType,
  TimelinePageResponseOutput as TimelinePageResponseOutputType,
  TimelineSnapshotResponseInput as TimelineSnapshotResponseInputType,
  TimelineSnapshotResponseOutput as TimelineSnapshotResponseOutputType,
  UserAnalysisCacheResponseInput as UserAnalysisCacheResponseInputType,
  UserAnalysisCacheResponseOutput as UserAnalysisCacheResponseOutputType,
  UserStatusResponseInput as UserStatusResponseInputType,
  UserStatusResponseOutput as UserStatusResponseOutputType,
} from './serializers';

export type TimelineAnalysisSettingsResponseInput = TimelineAnalysisSettingsResponseInputType;
export type TimelineAnalysisSettingsResponseOutput = TimelineAnalysisSettingsResponseOutputType;
export type TimelineAnalysisCancelResponseInput = TimelineAnalysisCancelResponseInputType;
export type TimelineAnalysisCancelResponseOutput = TimelineAnalysisCancelResponseOutputType;
export type TimelineAnalysisRealtimeTokenInput = TimelineAnalysisRealtimeTokenInputType;
export type TimelineAnalysisRealtimeTokenOutput = TimelineAnalysisRealtimeTokenOutputType;

export type TimelineInsightsResponseInput = TimelineInsightsResponseInputType;
export type TimelineInsightsResponseOutput = TimelineInsightsResponseOutputType;

export type TimelinePageResponse = TimelinePageResponseType;
export type MentionsTimelineResponse = MentionsTimelineResponseType;

export type TimelinePageResponseInput = TimelinePageResponseInputType;
export type TimelinePageResponseOutput = TimelinePageResponseOutputType;
export type MentionsTimelineResponseInput = MentionsTimelineResponseInputType;
export type MentionsTimelineResponseOutput = MentionsTimelineResponseOutputType;
export type UserAnalysisCacheResponseInput = UserAnalysisCacheResponseInputType;
export type UserAnalysisCacheResponseOutput = UserAnalysisCacheResponseOutputType;
export type TimelineSnapshotResponseInput = TimelineSnapshotResponseInputType;
export type TimelineSnapshotResponseOutput = TimelineSnapshotResponseOutputType;
export type UserStatusResponseInput = UserStatusResponseInputType;
export type UserStatusResponseOutput = UserStatusResponseOutputType;
export type ProfileStatusResponseInput = ProfileStatusResponseInputType;
export type ProfileStatusResponseOutput = ProfileStatusResponseOutputType;
export type TimelineLinkInsightsPayloadInput = TimelineLinkInsightsPayloadInputType;
export type TimelineLinkInsightsPayloadOutput = TimelineLinkInsightsPayloadOutputType;
export type TimelineInsightsSyncResponseInput = TimelineInsightsSyncResponseInputType;
export type TimelineInsightsSyncResponseOutput = TimelineInsightsSyncResponseOutputType;

export { TimelineInsightsSyncResponseSchema, TimelineLinkInsightsPayloadSchema } from '@sweetistics/contracts';
export {
  serializeTimelineAnalysisCancelResponse,
  serializeTimelineAnalysisRealtimeToken,
  serializeTimelineAnalysisSettingsResponse,
} from './analysis';
export { serializeTimelineInsightsResponse } from './insights';
export {
  MentionsTimelineResponseSchema,
  ProfileStatusResponseSchema,
  TimelineAnalysisMetadataSchema,
  TimelinePageResponseSchema,
  TimelineSnapshotResponseSchema,
  UserAnalysisCacheResponseSchema,
  UserStatusResponseSchema,
} from './schemas';
export {
  serializeMentionsTimelineResponse,
  serializeProfileStatusResponse,
  serializeTimelineInsightsSyncResponse,
  serializeTimelineLinkInsightsResponse,
  serializeTimelinePageResponse,
  serializeTimelineSnapshotResponse,
  serializeUserAnalysisCacheResponse,
  serializeUserStatusResponse,
} from './serializers';
